import type { ReactNode } from "react";
import { Card, CardContent, CardHeader } from "@rekonas/ui";

/** Presentation shared by the unlisted Operational tools. */
export function OperatorPanel({ title, description, children, current = false }: {
  title: string; description?: string; children: ReactNode; current?: boolean;
}) {
  return <section aria-label={title}>
    <Card className={`operator-panel${current ? " operator-panel-current" : ""}`}>
      <CardHeader><h2>{title}</h2>{description && <p>{description}</p>}</CardHeader>
      <CardContent className="operator-panel-content">{children}</CardContent>
    </Card>
  </section>;
}
